import { Component, OnInit } from '@angular/core';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';
import { ResearchService } from './research.service';

@Component({
  selector: 'app-research',
  templateUrl: './research.component.html',
  styleUrls: ['./research.component.scss']
})
export class ResearchComponent implements OnInit {
  allResearch;

  page: number = 1;
  pageSize: number = 12;
  collectionSize: number;
  rows: any[];

  constructor(
    private researchService: ResearchService,
    private gobalFunctionService: GobalFunctionService
  ) { }

  ngOnInit(): void {
    this.researchService.getAllResearch().pipe(
      map(res => {
        this.allResearch = res.result;
        this.refresh();
        this.gobalFunctionService.setSEO('วิจัยทั้งหมด', 'website', '');
      }),
      catchError((err) => {
        alert(err.error.message)
        return of(null);
      })
    ).subscribe();
  }

  refresh() {
    this.collectionSize = this.allResearch.length;
    this.rows = this.allResearch
      .map((account, i) => ({ id: i + 1, ...account }))
      .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
  }

}
